<template>
<div class="featureTab">
    <fg-input type="search" :placeholder="$t('button.search')" v-model.lazy="filter.text" addon-left-icon="fa fa-search"></fg-input>
    <SelectList :options="typeSearchOptions" value="NOFILTER" @select="(val)=>this.filter.typeOption = val"/>
    
    <hr>
  
    <div id="itemListBase" ref="itemListBase" >
      <div id="itemList">
        <template v-for="(item) in this.printedList">
          <MapStopEntry :entry="item" :key="item.tunnus" @click="selectedItem"></MapStopEntry>
        </template>
      </div>
    </div>
    <div id="paginat" v-if="totalRows > listLimit">
      <b-pagination
        class="map-pagination"
        v-model="currentPage"
        :total-rows="this.totalRows"
        :per-page="this.listLimit"
        align="fill"
        first-number
        last-number
        limit="2">
      </b-pagination>
    </div>
   
    <transition name="slide">
        <div class="slidein" v-if="item">
          <MapStopDetails v-if="this.item" :key="this.item.tunnus" :itemId="this.item.tunnus" @hideItemDetails="hideItemDetails"></MapStopDetails>
        </div>
    </transition>
</div>
</template>
<style scoped lang="scss">
div.featureTab {
  max-height: 90%;
  display: flex;
  flex-direction: column;

  #itemListBase {
    display:flex;
    flex-flow: column;
    overflow: auto;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: stretch;
    justify-content: flex-start;
    align-items: stretch;
  }
}
#itemList {
  flex-grow:4;
}

#paginat {
  order: 99;
}
</style>

<script>
import MapStopEntry from '@/components/Map/MapStopEntry'
import MapStopDetails from '@/components/Map/MapStopDetails'
import mapstore from '@/store/map/mapstore'


export default {
  name: 'Stops',
  components: {
    MapStopEntry,
    MapStopDetails
  },
  props: {
   // msg: String
  },
  data: function() {
    return {
      stopList: null,
      currentPage: 1,
      listLimit:  30,
      item: null,
      filter: {
        text: "",
        typeOption: "NOFILTER"
      },
      lineTypes: []
    }
  },
  beforeCreate: function() {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule("mapstore" , mapstore);
    }
  },
  watch: {
    filter: {
      deep: true,
      handler(newFilter) {
        //console.log("filtteröity filter: " + newFilter.typeOption);
        this.$store.commit('mapstore/setStopFilter',newFilter);
        this.updateData();
        this.$emit("filterUpdated");
	setTimeout(this.tuneListLenght,200); 
      }
    }
  },
  computed: { 
      totalRows() {
        return this.stopList ? this.stopList.length : 0;
      },
      printedList() {
        var begin = (this.currentPage-1)*this.listLimit;
        var end = begin + this.listLimit;
        return this.stopList ? this.stopList.slice(begin,end) : [];
      },
      typeSearchOptions() {
        var options = [];
        //options.push({id: "NOFILTER", label:this.$t("map.vehicles_tab.filter_no_filter"), icon: "filter"});
        options.push({id: "NOFILTER", label: this.$t("filter.no"), icon: "filter", caption: this.$t('map.label.stop_linetype')});

        this.lineTypes.forEach(l => {
          var option = {id: ""+l, label: this.$t("map.stop_type." + l), icon: null};
          options.push(option);
        });
  
        options.sort( (a, b) =>{
          if(a.id == "NOFILTER" || a.id == null) {
            return -1;
          } else if(b.id == "NOFILTER" || b.id == null) {
            return 1;
          }
          return a.id.localeCompare(b.id);
        });
        return options;
      }
  },
  mounted: function() {
    this.updateData();
    setTimeout(this.tuneListLenght,200); 
  },
  methods : {
    listOverflows: function() {
      try {
        let elem = this.$refs.itemListBase;
        let result = elem.scrollHeight > elem.clientHeight;
        return result;
      }catch(err) {
        return false;
      }
    },
    tuneListLenght: function() {
      if(this.listOverflows()) {
        this.listLimit = this.listLimit -1;
        setTimeout(this.tuneListLenght,100); 
      }
    },
    selectedItem(tunnus) {
      this.showItemDetails(tunnus);
      this.$emit('itemSelected', this.item);
    },
    showItemDetails(tunnus) {
      var selected = this.stopList.filter(i => i.tunnus == tunnus);
      this.item = selected[0];
    },
    hideItemDetails() {
      this.item = null;
      this.$emit("detailClosed");
    },
    updateData() {
      let $vm = this;
      this.$store.dispatch('mapstore/getStopsForTable').then((data) => {
        $vm.stopList = JSON.parse(JSON.stringify(data));

        if (this.lineTypes.length === 0) {
          var linetypeSet = new Set();
          this.stopList.forEach(stop => {
            try {
              if (stop.stopFeatures.LINE_TYPE.length === 1) {
                //console.log("linetype " + stop.stopFeatures.LINE_TYPE);
                linetypeSet.add(stop.stopFeatures.LINE_TYPE);
              }
            } catch(err){/*empty*/}
          });
          this.lineTypes = Array.from(linetypeSet);
          setTimeout(this.tuneListLenght,200); 
        }
      },()=>{ this.$travellerGetDataError();});
    }
  }
}
</script>

